export const site = {
  name: "Lucas Rocha",
  role: "Publicitário",
  email: "contato@olucasrocha.com.br",
  positioning:
    "Lucas transforma ferramentas e possibilidades de inteligência artificial em histórias visuais, demonstrações de produto e tutoriais que qualquer pessoa consegue entender.",
};

export const navItems = [
  { id: "projetos", label: "Projetos" },
  { id: "sobre", label: "Sobre" },
  { id: "servicos", label: "Serviços" },
  { id: "contato", label: "Contato" },
];

export const heroMessages = [
  { id: "msg-1", lines: ["Você merece", "se destacar."] },
  { id: "msg-2", lines: ["Inteligência artificial", "não é só uma ferramenta."] },
  { id: "msg-3", lines: ["É uma nova linguagem", "para criar histórias."] },
  { id: "msg-4", lines: ["Eu transformo tecnologia", "em conteúdo que as", "pessoas entendem."] },
];

export const heroSideLabels = {
  topics: "IA · NARRATIVA · VÍDEO",
  availability: "DISPONÍVEL PARA PROJETOS",
  nowLabel: "AGORA",
  nowText: "Criando experimentos visuais com inteligência artificial",
  focusLabel: "FOCO",
  focusItems: ["Lançamentos", "Tutoriais", "Experiências"],
  contactLabel: "CONTATO",
};

export const marqueeItems = [
  "Inteligência artificial",
  "Narrativa visual",
  "Demonstração de produto",
  "Direção criativa",
  "Tutoriais",
  "Experiências interativas",
  "Lançamentos",
];

export const projects = [
  {
    id: "projeto-1",
    number: "01",
    title: "Apresentando uma nova geração de vídeo",
    category: "Campanha de lançamento",
    description:
      "Uma demonstração visual criada para transformar uma tecnologia complexa em uma história simples, rápida e fácil de entender.",
    image: "/assets/project-1.jpg",
    alt: "Rosto de Lucas Rocha com um visor digital se formando em partículas azuis",
  },
  {
    id: "projeto-2",
    number: "02",
    title: "Quando a inteligência artificial vira cinema",
    category: "Narrativa visual",
    description:
      "Uma experiência que combina roteiro, direção criativa e geração por inteligência artificial para criar cenas que antes exigiriam uma produção inteira.",
    image: "/assets/project-2.jpg",
    alt: "Lucas Rocha diante de uma mesa holográfica, manipulando cenas de cinema em telas transparentes",
  },
  {
    id: "projeto-3",
    number: "03",
    title: "Uma experiência digital que reage ao usuário",
    category: "Experiência interativa",
    description:
      "Um projeto que transforma conteúdo, movimento e tecnologia em uma experiência que convida o público a continuar explorando.",
    image: "/assets/project-3.jpg",
    alt: "Carrossel de telas de conteúdo flutuando ao redor de Lucas Rocha",
  },
];

export const about = {
  label: "SOBRE",
  headline: "Eu traduzo o futuro da inteligência artificial para o presente.",
  body: "Meu trabalho é transformar ferramentas, modelos e possibilidades de inteligência artificial em conteúdos que despertam curiosidade e fazem sentido para pessoas reais. Eu uno roteiro, demonstração de produto, narrativa visual e direção criativa para apresentar tecnologia de um jeito simples, interessante e memorável.",
  secondary:
    "De vídeos educativos a experiências cinematográficas, cada projeto começa com a mesma pergunta: como transformar essa tecnologia em algo que as pessoas realmente queiram assistir?",
  visualCaption: "FRAME · EXPERIMENTO VISUAL COM IA",
};

export const services = [
  { number: "01", title: "Campanhas para lançamento de produtos de IA" },
  { number: "02", title: "Roteiro e demonstração de ferramentas" },
  { number: "03", title: "Direção criativa com inteligência artificial" },
  { number: "04", title: "Experiências visuais e interativas" },
];

export const socialsContent = {
  label: "REDES SOCIAIS",
  headline: "Continue acompanhando os próximos experimentos.",
  links: [
    { id: "instagram", label: "Instagram", handle: "@lucasrochaator", url: "https://www.instagram.com/lucasrochaator/" },
    { id: "tiktok", label: "TikTok", handle: "@lucas.rocha", url: "https://www.tiktok.com/@lucas.rocha" },
    { id: "youtube", label: "YouTube", handle: "@olucasrocha", url: "https://www.youtube.com/@olucasrocha" },
  ],
};

export const contactContent = {
  label: "CONTATO",
  headline: "Tem uma ideia? Vamos transformar em projeto.",
  demoNotice: "Ambiente de demonstração. Não envie informações pessoais reais.",
  consentLabel:
    "Autorizo o contato sobre este pedido. Ambiente de demonstração: os dados são apagados automaticamente em 24 horas.",
};

export const projectTypes = [
  "Campanha de lançamento",
  "Conteúdo patrocinado",
  "Direção criativa",
  "Experiência interativa",
  "Outro",
];

export const budgetRanges = [
  "Até R$ 10 mil",
  "R$ 10 mil a R$ 25 mil",
  "R$ 25 mil a R$ 50 mil",
  "Acima de R$ 50 mil",
  "Prefiro conversar",
];

export const leadStatuses = ["Novo", "Em contato", "Fechado", "Arquivado"];
